import { LinkButton } from "@vericus/cadmus-ui";

import { useParams } from "react-router-dom";

import { API_ENDPOINT } from "@/config";
import { useRespondusLDB } from "@/hooks/use-respondus-ldb";

interface Props {
  // Link contents.
  // @default "Return to login"
  label?: string;
}

// Link to return to the LMS for re-authentication for the assessment given in
// the URL. Not allowed for Respondus LockDownBrowser modes.
export function LMSReturnLink(props: Props) {
  const { label = "Return to login" } = props;
  const { tenant, assessmentId } = useParams();
  const { isLDBExam } = useRespondusLDB();

  if (
    !tenant ||
    !assessmentId ||
    tenant === "" ||
    assessmentId === "" ||
    isLDBExam
  ) {
    return null;
  }

  const returnUrl = new URL(`${API_ENDPOINT}/auth/lms_return`);
  returnUrl.searchParams.set("tenant", tenant);
  returnUrl.searchParams.set("assessment_id", assessmentId);

  return (
    <LinkButton
      onClick={() => {
        window.location.href = returnUrl.toString();
      }}
    >
      {label}
    </LinkButton>
  );
}
